import PropTypes from 'prop-types';
import { Card } from '../../../shared';

function OrdersShowProductDetails({ order }) {
  return (
    <Card className="h-full p-4">
      <table className="w-full text-black/80">
        <thead className="sr-only text-left text-black/80 text-sm sm:not-sr-only">
          <tr>
            <th scope="col" className="py-2 pr-8 font-medium sm:w-2/5 lg:w-1/3">
              Product
            </th>
            <th
              scope="col"
              className="hidden py-2 pr-8 text-right font-medium sm:table-cell"
            >
              Quantity
            </th>
            <th
              scope="col"
              className="hidden py-2 pr-8 text-right font-medium sm:table-cell"
            >
              Discounts
            </th>
            <th
              scope="col"
              className="hidden py-2 pr-8 text-right font-medium sm:table-cell"
            >
              Tax
            </th>
            <th
              scope="col"
              className="py-2 pr-8 text-right font-medium sm:table-cell"
            >
              Line Total
            </th>
            <th
              scope="col"
              className="py-2 pr-8 text-right font-medium sm:table-cell"
            />
          </tr>
        </thead>
        <tbody className="divide-y divide-black/20 border-black/20 border-b text-sm sm:border-t">
          {order.orderItems.map((orderItem) => (
            <tr key={orderItem.id}>
              <td className="py-2 pr-8">
                <div className="flex items-center">
                  <img
                    src={orderItem.product.featuredImage}
                    alt={orderItem.name}
                    className="mr-6 size-12 rounded-sm object-cover object-center"
                  />
                  <div>
                    <div className="font-medium text-black">
                      {orderItem.name}&nbsp;
                      {orderItem.patient && (
                        <span className="font-normal text-xs capitalize">
                          (For {orderItem.patient.firstName}&nbsp;
                          {orderItem.patient.lastName})
                        </span>
                      )}
                    </div>
                    <div className="mt-1 sm:hidden">
                      ${(orderItem.price / 100).toFixed(2)}
                    </div>
                  </div>
                </div>
              </td>
              <td className="hidden py-4 pr-8 text-right sm:table-cell">
                {orderItem.quantity}
              </td>
              <td className="hidden py-4 pr-8 text-right text-rccallouts-danger sm:table-cell">
                (${(orderItem.discountAmount / 100).toFixed(2)})
              </td>
              <td className="hidden py-4 pr-8 text-right sm:table-cell">
                ${(orderItem.taxAmount / 100).toFixed(2)}
              </td>
              <td className="hidden py-4 pr-8 text-right sm:table-cell">
                ${(orderItem.price / 100).toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot className="text-black leading-3">
          <tr className="h-10 w-full border-black/30 border-t-4" />
          <tr>
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="py-4 pr-8 text-right">Sub Total</td>
            <td />
            <td className="px-3 py-4 text-right">
              ${((order.total - order.shippingAmount) / 100).toFixed(2)}
            </td>
          </tr>
          <tr>
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="py-4 pr-8 text-right">Shipping</td>
            <td />
            <td className="px-3 py-4 text-right">
              ${(order.shippingAmount / 100).toFixed(2)}
            </td>
          </tr>
          <tr>
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="py-4 pr-8 text-right">Tax</td>
            <td />
            <td className="px-3 py-4 text-right">
              ${(order.taxAmount / 100).toFixed(2)}
            </td>
          </tr>
          <tr>
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="hidden md:table-cell" />
            <td className="py-4 pr-8 text-right">Total</td>
            <td />
            <td className="px-3 py-4 text-right">
              ${(order.total / 100).toFixed(2)}
            </td>
          </tr>
        </tfoot>
      </table>
    </Card>
  );
}

OrdersShowProductDetails.propTypes = {
  order: PropTypes.object.isRequired,
};

export default OrdersShowProductDetails;
